var exports = {
  "i": "xaee3c4fa--1d9617--wrapper",
};

module.exports = exports;
